@for (option of options$ | async; track option.value) {
    <sd-checkbox [label]="option.label" [formControl]="formArray.controls[$index]"/>
}
